import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './lib/sentry'
import './index.css'
import App from './App.tsx'

declare const __GIT_HASH__: string;
console.log(`[snagg] web-dashboard ${__GIT_HASH__}`);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
